import { select } from '@ngneat/elf';
import { createRequestDataSource } from '@ngneat/elf-requests';

import { AuditDetails } from './audits-details.model';
import { auditDetailsStore } from './audits-details.store';

export const getAuditDetailsDataSource = createRequestDataSource({
  store: auditDetailsStore,
  data$: () => auditDetailsStore.pipe(select((state) => state as AuditDetails)),
  requestKey: 'getAuditDetails',
  dataKey: 'auditDetails',
});
